"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _generalStore = _interopRequireDefault(require("general-store"));

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _immutable = require("immutable");

var _ActionFormActionTypes = _interopRequireDefault(require("crm_ui/flux/integrations/ActionFormActionTypes"));

var _instances = new _immutable.Map();

var _getId = function _getId(appId, formId, contactId) {
  return (0, _immutable.fromJS)({
    appId: appId,
    contactId: contactId,
    formId: formId
  });
};

var _getFormId = function _getFormId(form) {
  return _getId(form.get('appId'), form.get('formId'), form.get('contactId'));
};

var _getDynamicFormId = function _getDynamicFormId(form) {
  return [_getFormId(form), 'dynamicForm'];
};

var _getSubmissionResponseId = function _getSubmissionResponseId(form) {
  return [_getFormId(form), 'submissionResponse'];
};

var _isDynamic = function _isDynamic(fields) {
  var indexOfDynamic = fields != null ? fields.findIndex(function (field) {
    return field.get('type').indexOf('Dynamic' >= 0);
  }) : undefined;
  return indexOfDynamic >= 0;
};

var _hydrateForm = function _hydrateForm(data) {
  var formInstance = data.get('formInstance');
  return formInstance.withMutations(function (form) {
    return form.set('appId', data.get('appId')).set('contactId', data.get('contactId')).set('isDynamic', _isDynamic(formInstance.get('fields')));
  });
};

var _setError = function _setError(object) {
  return object.merge((0, _immutable.fromJS)({
    error: true,
    fields: [],
    loading: false
  }));
};

var _setLoading = function _setLoading(object) {
  return object.merge((0, _immutable.fromJS)({
    loading: true,
    fields: []
  }));
};

var _unsetLoading = function _unsetLoading(object) {
  return object.set('loading', false);
};

var _default = _generalStore.default.define().defineGet(function (appId, formId, contactId) {
  return _instances.get(_getId(appId, formId, contactId));
}).defineResponseTo(_ActionFormActionTypes.default.INSTANCE_FETCHED, function (data) {
  _instances = _instances.set(_getFormId(data), _hydrateForm(data));
}).defineResponseTo(_ActionFormActionTypes.default.INSTANCE_FETCH_FAILED, function (data) {
  _instances = _instances.set(_getFormId(data), _setError(data));
}).defineResponseTo(_ActionFormActionTypes.default.INSTANCE_REQUESTED, function (data) {
  _instances = _instances.set(_getFormId(data), _setLoading(data));
}).defineResponseTo(_ActionFormActionTypes.default.DYNAMIC_FORM_FETCHED, function (data) {
  _instances = _instances.setIn(_getDynamicFormId(data), _unsetLoading(data.get('dynamicFormInstance')));
}).defineResponseTo(_ActionFormActionTypes.default.DYNAMIC_FORM_FETCH_FAILED, function (data) {
  _instances = _instances.setIn(_getDynamicFormId(data), _setError(data));
}).defineResponseTo(_ActionFormActionTypes.default.DYNAMIC_FORM_REQUESTED, function (data) {
  _instances = _instances.setIn(_getDynamicFormId(data), _setLoading(data));
}).defineResponseTo(_ActionFormActionTypes.default.FORM_SUBMITTED, function (data) {
  _instances = _instances.setIn(_getSubmissionResponseId(data), _unsetLoading(data.get('submissionResponse')));
}).defineResponseTo(_ActionFormActionTypes.default.FORM_SUBMISSION_FAILED, function (data) {
  _instances = _instances.setIn(_getSubmissionResponseId(data), _setError(data));
}).defineResponseTo(_ActionFormActionTypes.default.FORM_SUBMISSION_REQUESTED, function (data) {
  _instances = _instances.setIn(_getSubmissionResponseId(data), _setLoading(data));
}).register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;